import Header from "../components/header";
import React from "react";

const TermsAndServices = () => {
  <Header />;
  return (
    <div className="bg-[#F2F1F6] py-8 lg:py-16 lg:px-12">
      <h1 className="mb-10 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl text-[#016A9E] text-center">
        Terms And Conditions
      </h1>
      <h2 className="mb-8 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
        Welcome to Essay Writer Pro!
      </h2>
      <div className="text-gray-700">
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          These terms and conditions outline the rules and regulations for using
          the Essay Writer Pro website and services ("Services"). By accessing
          our website and using our Services, you agree to comply with these
          terms and conditions. If you do not agree to any part of these terms,
          please do not continue to use Essay Writer Pro.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Copyright Policy
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          All content generated by our writers ("Generated Content") is the
          property of the respective users who commissioned the work. Essay
          Writer Pro does not claim any intellectual property rights over the
          Generated Content created for its users. However, we retain the right
          to use non-identifiable content samples for promotional purposes, with
          user consent.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          License to Use
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Subject to your compliance with these terms, Essay Writer Pro grants
          you a limited, non-exclusive, non-transferable, revocable license to
          access and use our Services solely for your personal, non-commercial
          academic purposes.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Trial Period and Subscription
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          <span className="font-bold">Trial Period:</span>
          Essay Writer Pro may offer a limited free trial period or sample work
          to new users. The duration and terms of any free trial will be clearly
          stated at the time of the offer.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          <span className="font-bold">Subscription: </span>
          Continued use of Essay Writer Pro's Services may require payment based
          on the specific writing services you choose. Details regarding service
          fees and payment plans are available on our website and during the
          order process.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Payment{" "}
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Payments must be made according to the service plan selected. Failure
          to make timely payments may result in the suspension or termination of
          your access to our Services. All payments are processed securely, and
          we do not store your payment information unless you opt for future
          use.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Functions of the Services
        </h2>
        <p className="mb-2 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - Custom academic writing, including essays, research papers, and
          other academic assignments.
        </p>
        <p className="mb-2 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - Editing and proofreading services.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - Academic consulting and guidance.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Each service is provided "as is" without any warranties of
          completeness, accuracy, or timeliness, and without any guarantees of
          specific academic outcomes.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          No Warranties
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Essay Writer Pro is provided "as is," with all faults. We expressly
          disclaim all warranties of any kind, whether express or implied,
          including, but not limited to, implied warranties of merchantability,
          fitness for a particular purpose, and non-infringement.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Limitation of Liability
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          In no event shall Essay Writer Pro, nor any of its officers,
          directors, or employees, be liable for any indirect, consequential, or
          special liabilities arising out of or in any way related to your use
          of our Services.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Indemnification
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          You agree to indemnify and hold harmless Essay Writer Pro and its
          directors, officers, employees, and agents from and against any and
          all claims, liabilities, damages, losses, or expenses, including
          reasonable attorneys' fees and costs, arising out of or in any way
          connected with your breach of these terms and conditions.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Severability
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          If any provision of these terms is found to be invalid or
          unenforceable under any applicable law, that provision shall be deemed
          omitted without affecting the remaining provisions herein.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Variation of Terms
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Essay Writer Pro reserves the right to revise these terms at any time
          as it sees fit. By using our Services, you are expected to review
          these terms regularly to ensure you understand any changes.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Assignment
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Essay Writer Pro may assign or transfer its rights and obligations
          under these terms without notification. However, you may not assign or
          transfer any rights or obligations under these terms.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Entire Agreement
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          These terms constitute the entire agreement between Essay Writer Pro
          and you concerning your use of our Services and supersede all prior
          agreements and understandings.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Contact Us
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          If you have any questions or concerns about our Privacy Policy or our
          practices, please do not hesitate to reach out to us. You can contact
          us at:
          <a
            href="mailto:info@thekaizenglobal.com"
            className="text-[#ba56d4] hover:underline"
          >
            {" "}
            info@thekaizenglobal.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default TermsAndServices;
